import {
    IDocumentos,
    IDocumentosTemplate,
    IListarUraTelefone,
    IListarDocumentoTemplateRequest,
    IDocumentoCasoConta,
    IListarModulo,
    IPreenchimentoTemplateRequest,
    IAssinaturasCasoDocumento,
} from "../../../Interfaces/Geral/Documentos/DocumentosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function InserirDocumentoCasoService(requestBody: IDocumentos) {
    const data = new FormData();
    data.append("DS_DOCUMENTO", requestBody.DS_DOCUMENTO);
    data.append("ID_CASO", `${requestBody.ID_CASO}`);
    data.append("ID_TIPO_DOCUMENTO", `${requestBody.ID_TIPO_DOCUMENTO}`);
    data.append("File", requestBody.File);

    const response = await Axios.post(
        `/home/documentos/inserirdocumentocaso`,
        data
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function ListarDocumentoTemplateService(
    filtro?: IListarDocumentoTemplateRequest
) {
    const urlParams = new URLSearchParams();
    if (filtro?.idTipoCaso)
        urlParams.append("idTipoCaso", filtro.idTipoCaso.toString());
    if (filtro?.FL_CONTRATO !== undefined)
        urlParams.append("FL_CONTRATO", String(filtro.FL_CONTRATO));
    if (filtro?.idProduto !== undefined)
        urlParams.append("idProduto", String(filtro.idProduto));
    if (filtro?.FL_NAO_CARREGA_TEMPLATE)
        urlParams.append(
            "FL_NAO_CARREGA_TEMPLATE",
            String(filtro.FL_NAO_CARREGA_TEMPLATE)
        );

    const response = await Axios.get<Array<IDocumentosTemplate>>(
        `/home/documentos/listardocumentotemplate?` + urlParams.toString()
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function GetDocumentoTemplateService(idDocumentoTemplate: number) {
    return Service(
        Axios.get<IDocumentosTemplate>(
            `/home/documentos/getdocumentotemplate?idDocumentoTemplate=${idDocumentoTemplate}`
        )
    );
}

export async function SetVariaveisDocumentoService(
    idDocumentoTemplate: number,
    idCaso: number,
    IdModulo: number,
    idParcela?: number,
    idChaveERP?: string
) {
    return Service(
        Axios.get(
            `/home/documentos/setvariaveisdocumento?ID_DOCUMENTO_TEMPLATE=${idDocumentoTemplate}&IdCaso=${idCaso}&idTipoCaso=${IdModulo}&idParcela=${
                idParcela != null ? idParcela : 0
            }&idChaveERP=${idChaveERP && idChaveERP != null ? idChaveERP : ""}`
        )
    );
}

export async function PreencherTemplateEmailClienteService(
    idDocumentoTemplate: number,
    body: IPreenchimentoTemplateRequest
) {
    return Service(
        Axios.post(
            `home/agendamento/preenchertemplateemailcliente?idDocumentoTemplate=${idDocumentoTemplate}`,
            body
        )
    );
}

export async function ListarDocumentoTemplatePorClassificacaoService(
    idTipoCaso: number,
    idClassificacaoDocumento: number,
    flAtivo: boolean
) {
    return Service(
        Axios.get<Array<IDocumentosTemplate>>(
            `home/documentos/listardocumentotemplateporclassificacao?idTipoCaso=${idTipoCaso}&idClassificacaoDocumento=${idClassificacaoDocumento}&flAtivo=${flAtivo}`
        )
    );
}

export async function ListarDocTemplateService() {
    return Service(
        Axios.get<Array<IDocumentosTemplate>>(
            `/home/doctemplateform/listardoctemplateform`
        )
    );
}

export async function ListarUraTelefoneService() {
    return Service(
        Axios.get<Array<IListarUraTelefone>>(
            `/home/uratelefone/listauratelefone`
        )
    );
}

export async function DocumentoCasoContaService(
    idCasoConta: number,
    dsDocumento?: string,
    idCaso?: number
) {
    return Service(
        Axios.get<IDocumentoCasoConta>(
            `/home/casodocumento/getdocumentocasoconta?idCasoConta=${idCasoConta}&dsDocumento=${
                dsDocumento ?? ""
            }&idCaso=${idCaso ?? 0}`
        )
    );
}

export async function DocumentoCasoContaVistoriaService(
    idCasoConta: number,
    dsDocumento?: string,
    idCaso?: number
) {
    return Service(
        Axios.get<Array<IDocumentoCasoConta>>(
            `/home/casodocumento/getdocumentoscasoconta?idCasoConta=${idCasoConta}&dsDocumento=${
                dsDocumento ?? ""
            }&idCaso=${idCaso ?? 0}`
        )
    );
}

export async function ListarModulosService() {
    return Service(
        Axios.get<Array<IListarModulo>>(`/home/modulo/listarmodulos`)
    );
}

export async function ListarDocumentoTemplateTipoDocumentoService(
    ID_TIPO_DOCUMENTO: number
) {
    return Service(
        Axios.get<Array<IDocumentosTemplate>>(
            `/home/clienteemlote/listardocumentotemplatetipodocumento?ID_TIPO_DOCUMENTO=${ID_TIPO_DOCUMENTO}`
        )
    );
}

export async function GetAssinaturasCasoDocumentoService(idCasoConta: number) {
    return Service(
        Axios.get<IAssinaturasCasoDocumento>(
            `/home/casodocumento/getassinaturascaso?idCasoConta=${idCasoConta}`
        )
    );
}
